import React, { useEffect, useRef, useState } from "react";
import { COUNTRY_CODES, searchCountryCodes } from "../utils/countryCodes";

function CountryCodeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);
  const searchRef = useRef(null);

  const selected = COUNTRY_CODES.find((c) => c.code === value) || COUNTRY_CODES[0];
  const results = searchCountryCodes(query);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    if (open) {
      setQuery("");
      setTimeout(() => searchRef.current?.focus(), 0);
    }
  }, [open]);

  return (
    <div className="country-code-picker" ref={wrapRef}>
      <button
        type="button"
        className="country-code-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-label="Select country code"
      >
        <span>{selected.flag} {selected.code}</span>
        <span className="country-code-caret">▾</span>
      </button>

      {open && (
        <div className="country-code-dropdown">
          <input
            ref={searchRef}
            type="text"
            className="country-code-search"
            placeholder="Search country or code"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="country-code-list">
            {results.length === 0 && (
              <div className="country-code-empty">No matches</div>
            )}
            {results.map((c) => (
              <button
                type="button"
                key={c.code + c.iso2}
                className={"country-code-option" + (c.code === value ? " selected" : "")}
                onClick={() => {
                  onChange(c.code);
                  setOpen(false);
                }}
              >
                <span className="country-code-option-name">{c.flag} {c.name}</span>
                <span className="country-code-option-code">{c.code}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CountryCodeSelect;
